




















import { Vue, Component, Prop } from "vue-property-decorator"

@Component
export default class ConstructingBar extends Vue {
  @Prop(Number) public isConstructing: number
  @Prop(String) public source: string
  @Prop(Boolean) public demo: boolean | undefined

  get timeToBuild() {
    const source = this.$store.state.energySources.find(
      (source) => source.name === this.source
    )
    if (source != null) {
      return source.timeToBuild
    }
  }

  get constructionInfo() {
    if (this.demo) {
      return 50
    } else {
      this.$store.state.inventory.inventoryChangeNum
      const ans =
        1 -
        Math.abs(this.isConstructing) / this.timeToBuild +
        1 / this.timeToBuild -
        1 / this.timeToBuild +
        this.$store.state.timeVal / (60 * 1000 * 60 * 24) / this.timeToBuild
      // console.log(ans)
      const val = 100.0 * ans
      if (val <= 0 || isNaN(val)) {
        return 0
      } else {
        return val
      }
      return ans
    }
  }
}
